import styled, { css } from "styled-components"

import { minWidth, when } from "utils"

export const PaddedContainer = styled.div`
  margin-bottom: 1.6rem;

  ${minWidth.tablet`
    padding: 0 1.5rem;
    margin-bottom: ${(props) => (props.singleCol ? "1.6rem" : "3rem")};
  `}
`

export const Container = styled.div`
  position: relative;
  display: inline-block;
  height: fit-content;
  width: 100%;

  ${({ isArticleFAQ }) =>
    isArticleFAQ
      ? css`
          background: #fafafa;

          & > h3 {
            font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
            font-size: 2.1rem;
            line-height: 1.35;

            ${minWidth.tablet`
              font-size: 1.8rem;
              line-height: 1.7778;
            `}
          }

          p {
            margin: 0;
            padding: 0 2.5rem 1rem;
            font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
            font-size: 1.6rem;
            line-height: 1.375;
          }

          a {
            color: ${({ theme }) => theme.article.color};
          }
        `
      : css`
          border-radius: 0.5rem;
          background: #fff;
          box-shadow: 0 0.2rem 0.7rem rgba(145, 145, 145, 0.35);
          white-space: break-spaces;

          & > h3 {
            font-size: 2.1rem;
            line-height: 1.35;
            white-space: break-spaces;

            ${minWidth.tablet`
              font-size: 2.2rem;
              line-height: 1.45;
            `}
          }

          p {
            margin: 0;
            font-size: 1.6rem;
            line-height: 1.375;
          }

          ul, ol {
            padding-left: 0;
            margin: 0;
            list-style-position: inside;
          }

          code {
            white-space: break-spaces;
          }
        `}
`

export const Summary = styled.div`
  padding: ${({ isArticleFAQ }) =>
    isArticleFAQ ? "2.5rem 5rem 2.5rem 2.5rem" : "2.4rem 5rem 2.4rem 3rem"};
  display: flex;
  list-style: none;
  cursor: pointer;

  ::-webkit-details-marker {
    display: none;
  }

  ${minWidth.tablet`
    padding: ${({ isArticleFAQ }) =>
      isArticleFAQ ? "2.5rem 4rem 2.5rem 2.5rem" : "2.4rem 4rem 2.4rem 3rem"};
  `}
`

export const ArrowIndicator = styled.div`
  position: absolute;
  top: ${({ isArticleFAQ }) => (isArticleFAQ ? "2.7rem" : "2.6rem")};
  right: 3rem;
  padding: 0.5rem;
  border: solid ${({ isArticleFAQ }) => (isArticleFAQ ? "#C14E78" : "#747474")};
  border-width: 0 0.2rem 0.2rem 0;
  display: inline-block;
  transform: rotate(45deg);
  transform-origin: center;
  transition: transform 0.25s ease-in;

  ${when("isExpanded")`
    transform: rotate(-135deg);
  `}
`

export const Content = styled.div`
  padding: 0 2.4rem 2.4rem 3rem;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`

export const PreHeading = styled.span`
  font-size: 1.3rem;
  color: #767676;
  letter-spacing: 0.1rem;
  font-weight: 500;
  text-transform: uppercase;
`

export const SummaryAndContent = styled.div`
  transition: height 0.3s ease;
  overflow: hidden;
`

export const ReadMore = styled.div`
  position: relative;
  color: #bbb;
  font-size: 1.4rem;
  font-weight: 500;
  padding: 1.8rem 2.4rem 0 3rem;
  background-image: linear-gradient(rgba(255, 255, 255, 0.5), #fff 50%, #fff 0);
  bottom: 1.2rem;

  & a {
    cursor: pointer;
  }
`

export const Title = styled.h3`
  font-size: ${({ singleCol }) => (singleCol ? "2.2rem" : "2.5rem")};
  line-height: 3.2rem;
`
